import request from '../../utils/request';

export const search = (param) => {
    return request({
        url: '/supplier/search',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}
export const selPageSearch = (param) => {
        return request({
            url: '/supplier/selectPage',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: param
        })
    }
    // 问题报告中供应商弹窗的查询接口从原来的 /supplier/selectPage 替换为 /supplier/selectPageForDataScope 参数不变。
export const selectPageForDataScope = (param) => {
    return request({
        url: '/supplier/selectPageForDataScope',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}
export const disable = (param) => {
    return request({
        url: '/supplier/disable/',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}
export const add = (param) => {
    return request({
        url: '/supplier/add',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}
export const updateSupplier = (param) => {
    return request({
        url: '/supplier/updateSupplier',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}
export const getSupplierdetail = (param) => {
    return request({
        url: `/supplier/queryDataById/${param}`,
        method: 'get',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
    })
}
export const listGroups = (param) => {
    return request({
        url: `/supplier/groups`,
        method: 'get',
        params: param
    })
}
export const saveGroups = (data) => {
    return request({
        url: `/supplier/groups`,
        method: 'post',
        data: data
    })
}
export const delGroup = (groupId) => {
    return request({
        url: `/supplier/groups/${groupId}`,
        method: 'delete',
    })
}
export const listSupplierOfGroup = (groupId, param) => {
    return request({
        url: `/supplier/groups/${groupId}`,
        method: 'get',
        params: param
    })
}